import React, { useMemo, useState } from 'react'
import Header from "./Header"
import BaseUrl from '../BaseUrl'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import swal from "sweetalert";
import Footer from './Footer';

const bubbles = [
    { size: 260, left: '7%', top: '12%', opacity: 0.12, blur: 52, dur: 28, delay: -4 },
    { size: 180, left: '78%', top: '16%', opacity: 0.1, blur: 44, dur: 32, delay: -12 },
    { size: 160, left: '14%', top: '62%', opacity: 0.09, blur: 46, dur: 34, delay: -18 },
    { size: 130, left: '84%', top: '66%', opacity: 0.1, blur: 38, dur: 26, delay: -14 },
];

const PASSWORD_LENGTH_MESSAGE = "Password must be at least 6 characters.";

export default function ChangePassword() {
    const [password, setPassword] = useState("");
    const [confermPassword, setConfermPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const navigate = useNavigate()

    const primaryGradient = useMemo(
        () => ({
            backgroundImage: 'linear-gradient(90deg, #00C6FF 0%, #009BFF 40%, #0072FF 100%)',
        }),
        []
    );

    const strengthScore = useMemo(() => {
        return [
            password.length >= 6,
            /[A-Z]/.test(password),
            /[0-9]/.test(password),
            /[^A-Za-z0-9]/.test(password),
        ].filter(Boolean).length;
    }, [password]);

    const strengthLabel = ['Very weak', 'Weak', 'Good', 'Strong', 'Excellent'][strengthScore];
    const strengthColor = ['bg-slate-200', 'bg-red-400', 'bg-amber-400', 'bg-sky-500', 'bg-emerald-500'][strengthScore];

    const ChangePasswordUser = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const token = localStorage.getItem("authorization")
        var auth = {
            headers: {
                authorization: `bearer ${token}`,
            },
        };
        const url = BaseUrl() + "api/user/change-password";
        const data = {
            password: password,
            confermPassword: confermPassword

        };
        console.log("data", data)

        if (data.password.length < 6) {
            setIsSubmitting(false);
            swal(PASSWORD_LENGTH_MESSAGE);
            return
        }

        if (data.confermPassword.length < 6) {
            setIsSubmitting(false);
            swal(PASSWORD_LENGTH_MESSAGE);
            return
        }

        if (data.password === data.confermPassword) {
            try {
                console.log("intry")
                console.log("intry", auth)

                const response = await axios.post(url, data, auth);
                console.log("response")

                console.log(response)
                if (response.status === 200) {
                    localStorage.clear();
                    localStorage.setItem("authorization", response.data.token);
                    navigate("/login")
                }
                else {
                    swal(response.data.message);
                }
            } catch (error) {
                swal("Unable to update your password. Please try again.");
            } finally {
                setIsSubmitting(false);
            }
            return
        }
        setIsSubmitting(false);
        swal("Password and confirm password do not match.")
    };

    return (
        <div className="relative flex min-h-screen flex-col bg-[#F4FEFF]">
            <div className="relative z-20 shrink-0">
                <Header />
            </div>

            <main className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
                <div
                    className="pointer-events-none absolute inset-0"
                    style={{
                        backgroundImage: [
                            'linear-gradient(105deg, #CCF4FF 0%, #E8FBFF 28%, #FFFFFF 55%, #E6F4FF 100%)',
                            'radial-gradient(620px 420px at 50% 48%, rgba(0,198,255,0.28), transparent 68%)',
                            'radial-gradient(720px 480px at 92% 24%, rgba(0,114,255,0.09), transparent 72%)',
                        ].join(','),
                    }}
                />

                {bubbles.map((bubble, index) => (
                    <span
                        key={index}
                        className="bsi-bubble pointer-events-none absolute"
                        style={{
                            width: bubble.size,
                            height: bubble.size,
                            left: bubble.left,
                            top: bubble.top,
                            opacity: bubble.opacity,
                            filter: `blur(${bubble.blur}px)`,
                            animationDuration: `${bubble.dur}s`,
                            animationDelay: `${bubble.delay}s`,
                        }}
                    />
                ))}

                <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col items-center justify-center px-4 py-10 sm:py-12 lg:flex-row lg:items-center lg:justify-between lg:gap-10 xl:gap-14">
                    <aside className="mb-10 hidden max-w-md flex-shrink-0 lg:mb-0 lg:flex lg:flex-col lg:justify-center">
                        <div className="relative">
                            <div className="absolute -left-10 top-1/2 h-52 w-52 -translate-y-1/2 rounded-full bg-cyan-300/35 blur-3xl" />
                            <div className="absolute -right-6 top-6 h-36 w-36 rounded-full bg-[#0072FF]/22 blur-3xl" />
                            <div className="relative rounded-[28px] border border-white/85 bg-white/55 p-8 shadow-[0_28px_90px_rgba(2,132,199,0.16)] backdrop-blur-xl">
                                <div
                                    className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-[0_14px_34px_rgba(0,114,255,0.28)]"
                                    style={primaryGradient}
                                >
                                    <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="4" y="11" width="16" height="9" rx="2" />
                                        <path d="M8 11V7a4 4 0 018 0v4" />
                                    </svg>
                                </div>
                                <h2 className="text-2xl font-bold tracking-tight text-[#0F172A]">Create a secure password</h2>
                                <p className="mt-3 text-sm leading-relaxed text-[#64748B]">
                                    Use a password with at least 6 characters. Numbers and symbols can make it stronger.
                                </p>
                            </div>
                        </div>
                    </aside>

                    <div className="relative w-full max-w-[460px] shrink-0">
                        <div className="pointer-events-none absolute -inset-3 rounded-[30px] bg-gradient-to-br from-cyan-300/45 via-white/10 to-blue-400/35 opacity-90 blur-2xl" />
                        <div className="pointer-events-none absolute inset-x-10 -bottom-8 h-28 rounded-full bg-cyan-400/20 blur-2xl" />
                        <form
                            onSubmit={ChangePasswordUser}
                            className="relative rounded-[26px] border border-white/80 bg-[rgba(255,255,255,0.72)] p-7 shadow-[0_32px_100px_rgba(2,132,199,0.18)] backdrop-blur-xl sm:p-9"
                        >
                            <div className="mb-7 text-center">
                                <div
                                    className="mx-auto mb-5 inline-flex h-16 w-16 items-center justify-center rounded-3xl text-white shadow-[0_16px_38px_rgba(0,114,255,0.28)]"
                                    style={primaryGradient}
                                >
                                    <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                        <path d="M9 12l2 2 4-4" />
                                    </svg>
                                </div>
                                <h1 className="text-2xl font-bold tracking-tight text-[#0F172A] sm:text-[28px]">Change password</h1>
                                <p className="mt-2 text-sm leading-relaxed text-[#64748B]">
                                    Choose a new password to keep your Serendipity account protected.
                                </p>
                            </div>

                            <div className="space-y-5">
                                <div>
                                    <label htmlFor="new-password" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                                        New Password
                                    </label>
                                    <div className="relative">
                                        <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                                            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                                                <rect x="4" y="11" width="16" height="9" rx="2" />
                                                <path d="M8 11V7a4 4 0 018 0v4" />
                                            </svg>
                                        </span>
                                        <input
                                            id="new-password"
                                            className="min-h-[48px] w-full rounded-[12px] border border-black/10 bg-white/70 py-2.5 pl-12 pr-14 text-[15px] font-semibold leading-snug text-slate-800 shadow-[0_1px_3px_rgba(15,23,42,0.07)] outline-none transition-all duration-200 ease-out placeholder:text-slate-500 hover:border-black/[0.16] hover:bg-white/[0.78] focus:border-cyan-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(0,200,255,0.2)]"
                                            type={showPassword ? "text" : "password"}
                                            required
                                            value={password}
                                            onChange={(e) => {
                                                setPassword(e.target.value);
                                            }}
                                            placeholder="At least 6 characters"
                                            autoComplete="new-password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword((current) => !current)}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full px-2.5 py-1 text-xs font-bold text-cyan-700 transition hover:bg-cyan-50"
                                        >
                                            {showPassword ? "Hide" : "Show"}
                                        </button>
                                    </div>
                                    <div className="mt-3">
                                        <div className="h-2 overflow-hidden rounded-full bg-slate-200">
                                            <div className={`h-full rounded-full transition-all duration-300 ${strengthColor}`} style={{ width: `${Math.max(strengthScore, 1) * 25}%` }} />
                                        </div>
                                        <p className="mt-1.5 text-xs font-semibold text-slate-500">Strength: <span className="text-slate-800">{strengthLabel}</span></p>
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="confirm-password" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                                        Confirm Password
                                    </label>
                                    <div className="relative">
                                        <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                                            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M20 6L9 17l-5-5" />
                                            </svg>
                                        </span>
                                        <input
                                            id="confirm-password"
                                            className="min-h-[48px] w-full rounded-[12px] border border-black/10 bg-white/70 py-2.5 pl-12 pr-14 text-[15px] font-semibold leading-snug text-slate-800 shadow-[0_1px_3px_rgba(15,23,42,0.07)] outline-none transition-all duration-200 ease-out placeholder:text-slate-500 hover:border-black/[0.16] hover:bg-white/[0.78] focus:border-cyan-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(0,200,255,0.2)]"
                                            type={showConfirmPassword ? "text" : "password"}
                                            required
                                            value={confermPassword}
                                            onChange={(e) => {
                                                setConfermPassword(e.target.value);
                                            }}
                                            placeholder="Confirm new password"
                                            autoComplete="new-password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword((current) => !current)}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full px-2.5 py-1 text-xs font-bold text-cyan-700 transition hover:bg-cyan-50"
                                        >
                                            {showConfirmPassword ? "Hide" : "Show"}
                                        </button>
                                    </div>
                                    {confermPassword && password !== confermPassword ? (
                                        <p className="mt-1.5 text-sm font-medium text-red-600">Passwords do not match yet.</p>
                                    ) : confermPassword && confermPassword.length < 6 ? (
                                        <p className="mt-1.5 text-sm font-medium text-red-600">{PASSWORD_LENGTH_MESSAGE}</p>
                                    ) : null}
                                </div>

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={primaryGradient}
                                    className="w-full rounded-full py-3.5 text-base font-bold text-white shadow-[0_14px_38px_rgba(0,114,255,0.38)] transition duration-300 hover:scale-[1.02] hover:brightness-110 hover:shadow-[0_20px_48px_rgba(0,198,255,0.42)] active:scale-[0.98] disabled:pointer-events-none disabled:opacity-60"
                                >
                                    {isSubmitting ? "Updating..." : "Submit"}
                                </button>

                                <p className="text-center text-sm text-[#64748B]">
                                    Remembered it?{' '}
                                    <Link to="/login" className="font-bold text-cyan-700 underline-offset-4 transition hover:text-cyan-900 hover:underline">
                                        Sign In
                                    </Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </main>

            <div className="relative z-20 mt-auto shrink-0">
                <Footer />
            </div>
        </div>
    )
}
